import Reflux from 'reflux';

const RevisionActions = Reflux.createActions([
  // New data is applied to the store
  'update',
  'update_state',
  'selectRevisionScan',

  // Fetch update from server and apply
  'load',
  'loadMinimal',
  'loadDeepLicenses',
  'invalidateCache',
  'removeLicense',
  'addDependency',
  'resolveDependency',
  'scan',
  'rebuild',
]);

export default RevisionActions;
